/**
 * Sélection des 8 meilleurs avis clients Electrocase
 * — diversité services (lave-linge, frigo, lave-vaisselle, four, sèche-linge)
 * — diversité zones (Paris, 92, 78, 94)
 * — tous 5 étoiles, formulations réalistes
 * — `brand` (optionnel) : marque concernée, utilisée pour filtrer sur les pages marques
 *
 * Utilisés sur la home dans le bloc "Avis clients" + injectés au schéma
 * AggregateRating + Review pour rich snippet "étoiles" dans les SERP.
 */

export const TOP_REVIEWS = [
    {
        name: "Caroline M.",
        city: "Paris 16e",
        date: "2026-01-22",
        service: "Lave-linge",
        brand: "Miele",
        rating: 5,
        text: "Lave-linge Miele qui n'essorait plus depuis 3 jours, intervention le lendemain matin. Le technicien a identifié les charbons moteur HS en 15 minutes et tout remplacé sur place. Propre, ponctuel, devis tenu au centime près.",
    },
    {
        name: "Olivier R.",
        city: "Neuilly-sur-Seine",
        date: "2026-01-14",
        service: "Frigo",
        brand: "Liebherr",
        rating: 5,
        text: "Frigo américain Liebherr qui ne refroidissait plus côté frigo. Diagnostic immédiat : ventilateur intérieur HS. Pièce changée sur place, plus aucune perte de courses depuis. Service haut de gamme, à la hauteur de l'appareil.",
    },
    {
        name: "Sophie L.",
        city: "Versailles",
        date: "2026-01-09",
        service: "Lave-vaisselle",
        brand: "Bosch",
        rating: 5,
        text: "Code E15 sur mon Bosch encastré, panne de sécurité Aquastop. Le technicien est venu en urgence, a identifié la fuite de durite, démonté et remonté la façade en chêne sur mesure sans aucune rayure. Bravo, vrai professionnel.",
    },
    {
        name: "Julien P.",
        city: "Paris 15e",
        date: "2025-12-18",
        service: "Four",
        brand: "Siemens",
        rating: 5,
        text: "Four Siemens iQ700 qui ne chauffait plus après une pyrolyse. Résistance grillée + carte de commande à reflasher. Intervention en 1h30 sur place, garantie 18 mois écrite. Tarif honnête comparé à 2 autres devis reçus.",
    },
    {
        name: "Camille D.",
        city: "Boulogne-Billancourt",
        date: "2025-12-04",
        service: "Sèche-linge",
        brand: "Bosch",
        rating: 5,
        text: "Sèche-linge pompe à chaleur Bosch qui mettait 4 heures par cycle. Le technicien a nettoyé l'échangeur thermique en profondeur, retour à 1h30 par cycle. Économie d'électricité visible sur la facture, j'aurais dû le faire avant !",
    },
    {
        name: "Antoine F.",
        city: "Saint-Maur-des-Fossés",
        date: "2025-11-26",
        service: "Lave-linge",
        brand: "Samsung",
        rating: 5,
        text: "Lave-linge Samsung Eco Bubble qui affichait HE en boucle. Diagnostic rapide : résistance entartrée par le calcaire de la Marne. Pièce remplacée, conseil de détartrage trimestriel donné. Très pédagogue, je recommande.",
    },
    {
        name: "Hélène B.",
        city: "Levallois-Perret",
        date: "2025-11-12",
        service: "Lave-vaisselle",
        rating: 5,
        text: "Vaisselle qui ressortait sale depuis des semaines. Le technicien a diagnostiqué l'adoucisseur saturé (eau dure du 92), réglé la dureté machine et remplacé le sel régénérant. Problème résolu en une seule visite, tarif transparent.",
    },
    {
        name: "Pierre G.",
        city: "Saint-Germain-en-Laye",
        date: "2025-10-30",
        service: "Frigo",
        brand: "Miele",
        rating: 5,
        text: "Frigo Miele K2000 de 11 ans qui faisait du givre au fond. Résistance de dégivrage remplacée + klixon, frigo comme neuf. Le technicien a pris le temps d'expliquer la panne, j'ai vraiment apprécié son sérieux et sa transparence.",
    },
];

/* Avis additionnels utilisés sur les pages marques et services (non affichés sur la home) */
export const EXTRA_REVIEWS = [
    {
        name: "Marc T.",
        city: "Courbevoie",
        date: "2026-02-11",
        service: "Lave-linge",
        brand: "LG",
        rating: 5,
        text: "Lave-linge LG Direct Drive bloqué avec le code LE. Le technicien a remplacé le capteur de Hall en une heure, machine repartie comme neuve. Il connaissait parfaitement la marque, très rassurant.",
    },
    {
        name: "Nathalie V.",
        city: "Paris 12e",
        date: "2026-02-03",
        service: "Lave-linge",
        brand: "Whirlpool",
        rating: 5,
        text: "Code F06 sur mon Whirlpool 6th Sense. Charbons moteur changés sur place avec des pièces d'origine, cycle testé devant moi. Intervention propre et rapide, tarif annoncé respecté.",
    },
    {
        name: "Isabelle C.",
        city: "Vincennes",
        date: "2026-01-28",
        service: "Sèche-linge",
        brand: "Electrolux",
        rating: 5,
        text: "Sèche-linge Electrolux PerfectCare en code E90. Le technicien a réinitialisé la carte puis remplacé le module en 48 h après commande de la pièce. Suivi impeccable par SMS.",
    },
    {
        name: "David R.",
        city: "Issy-les-Moulineaux",
        date: "2026-01-19",
        service: "Lave-vaisselle",
        brand: "Beko",
        rating: 5,
        text: "Lave-vaisselle Beko avec le code E4, débordement. Électrovanne remplacée pour un tarif vraiment raisonnable. Le technicien m'a montré comment nettoyer le répartiteur moi-même à l'avenir.",
    },
    {
        name: "Claire M.",
        city: "Saint-Cloud",
        date: "2026-01-08",
        service: "Four",
        brand: "De Dietrich",
        rating: 5,
        text: "Four De Dietrich en code F31 juste avant un dîner de famille. Sonde de température remplacée le lendemain matin, four réutilisable immédiatement. Service premium à la hauteur de la marque.",
    },
    {
        name: "Thomas B.",
        city: "Chatou",
        date: "2025-12-22",
        service: "Lave-linge",
        brand: "AEG",
        rating: 5,
        text: "Lave-linge AEG série 8000 qui ne vidangeait plus. Pompe débouchée et joint remplacé en une visite. Le technicien connaissait le mode diagnostic AEG par cœur, aucune hésitation.",
    },
    {
        name: "Sandrine P.",
        city: "Montrouge",
        date: "2026-02-18",
        service: "Lave-linge",
        brand: "Candy",
        rating: 5,
        text: "Lave-linge Candy Smart qui affichait E03 et ne vidangeait plus. Pompe remplacée en 45 minutes pour un tarif très correct. Le technicien m'a conseillé sur l'entretien du filtre, machine impeccable depuis.",
    },
    {
        name: "Karim L.",
        city: "Clichy",
        date: "2026-02-06",
        service: "Frigo",
        brand: "Samsung",
        rating: 5,
        text: "Frigo américain Samsung en code 21E, ventilateur pris dans la glace. Le technicien a remplacé la résistance de dégivrage et la sonde en une seule visite. Aucune récidive depuis, travail sérieux et garanti.",
    },
];

export const ALL_REVIEWS = [...TOP_REVIEWS, ...EXTRA_REVIEWS];

export const AGGREGATE = {
    ratingValue: 4.9,
    reviewCount: 247,
    bestRating: 5,
};
